<template>
  <div>
    <br />
    <center>
      <h4 class="title is-4">Leave Approval Status</h4>
      <hr />
      <div v-if="isLoadingData">
        <img src="../../assets/loading.gif" width="60" height="60" />
      </div>
      <div v-else>
        <div class="notification is-success" v-show="successMsg !== null">
          {{successMsg}}
        </div>
        <div class="notification is-danger" v-show="errorMsg !== null">
          {{errorMsg}}
        </div>
      </div>
    </center>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    successMsg: null,
    errorMsg: null,
    isLoadingData: false
  }),
  created() {
    var hashAccess = this.$route.params.hashCode
    var otherHashAccess = this.$route.params.otherHashCode
    var isApprove = this.$route.params.action
    var approverEmail = this.$route.params.approverEmail
    var leaveId = this.$route.params.leaveId

    if (hashAccess) {
      this.updateLeaveStatus(
        hashAccess,
        isApprove,
        otherHashAccess,
        approverEmail,
        leaveId
      )
    }
  },
  methods: {
    updateLeaveStatus(hashAccess, isApprove, otherHashAccess, approverEmail, leaveId) {
      this.isLoadingData = true
      this.successMsg = null
      this.errorMsg = null
      axios
        .post(
          `api/employeessleaves/leave-approval/${hashAccess}/${isApprove}/${leaveId}/${otherHashAccess}/${approverEmail}`
        )
        .then(response => {
          this.successMsg = response.data
        })
        .catch(error => {
          this.errorMsg = error.response.data
        })
        .then(() => {
          this.isLoadingData = false
        })
    }
  }
}
</script>
